<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">{{ $route.params.id ? "Edit Corporate Pass" : "New Corporate Pass" }}</h3>
                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <!-- Form -->
        <form @submit.prevent="save">
            <div class="form-group row align-items-center">
                <label class="col-md-2 mb-0">Company</label>
                <div class="col-md-5 pl-md-0 fit-content">
                    <span v-if="$route.params.id">{{ company }}</span>
                    <select class="custom-select" v-model="company" v-else>
                        <option v-for="(item, i) in companies" :key="i" :value="item.CompanyName">
                            {{ item.CompanyName }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="form-group row align-items-center">
                <label class="col-md-2 mb-0">Type</label>
                <div class="col-md-4 pl-md-0 fit-content">
                    <select class="custom-select" v-model="type">
                        <option :value="corporatePassType.physicalCard">{{ corporatePassType.physicalCard }}</option>
                        <option :value="corporatePassType.eTicket">{{ corporatePassType.eTicket }}</option>
                    </select>
                </div>
            </div>
            <div class="form-group row align-items-center">
                <label class="col-md-2 mb-0">Code</label>
                <div class="col-md-4 pl-md-0">
                    <input type="text" class="form-control" v-model="code" max-length="100" required />
                </div>
            </div>
            <div class="form-group row align-items-center">
                <label class="col-md-2 mb-0">Name</label>
                <div class="col-md-4 pl-md-0">
                    <input type="text" class="form-control" v-model="name" max-length="250" required />
                </div>
            </div>

            <template v-if="type == corporatePassType.physicalCard">
                <div class="form-group row align-items-center">
                    <label class="col-md-2 mb-0">Total number of pass/e-tickets</label>
                    <div class="col-md-1 pl-md-0">
                        <input type="number" class="form-control" v-model="totalPass" max="9999" min="1" step="1"
                            required />
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label class="col-md-2 mb-0">Number of pass/e-tickets allowed per booking</label>
                    <div class="col-md-1 pl-md-0">
                        <input type="number" class="form-control" v-model="passAllowedPerBooking" max="9999" min="1"
                            step="1" required />
                    </div>
                </div>
            </template>
            <div class="form-group row align-items-center">
                <label class="col-md-3 mb-0 fit-content">Employee has to collect the pass</label>
                <div class="col-md-1 pl-md-0">
                    <input type="number" class="form-control" v-model="collectionDay" max="9999" min="1" step="1"
                        required />
                </div>
                <label class="col-md-2 mb-0 pl-0">days before booking date</label>
            </div>
            <template v-if="type == corporatePassType.physicalCard">
                <div class="form-group row align-items-center">
                    <label class="col-md-3 mb-0 fit-content">Employee has to return the pass</label>
                    <div class="col-md-1 pl-md-0 ml-1">
                        <input type="number" class="form-control" v-model="returnDay" max="9999" min="1" step="1"
                            required />
                    </div>
                    <label class="col-md-2 mb-0 pl-0">days after booking date</label>
                </div>
                <div class="form-group row align-items-center">
                    <label class="col-md-3 mb-0 fit-content">
                        If return day falls on public holiday, employee can return pass
                    </label>
                    <div class="col-md-1 pl-md-0">
                        <input type="number" class="form-control" v-model="returnDayAfterPH" max="9999" min="1" step="1"
                            required />
                    </div>
                    <label class="col-md-2 mb-0 pl-0">days after public holiday</label>
                </div>
            </template>

            <div class="form-group row align-items-center">
                <label class="col-md-2 mb-0">Status</label>
                <div class="col-md-2 pl-md-0">
                    <select class="custom-select" v-model="status">
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                    </select>
                </div>
            </div>

            <template v-if="type == corporatePassType.eTicket" v-for="(quota, i) in quotas">
                <div class="form-group row align-items-center">
                    <div class="col-md-6">
                        <hr />
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label class="col-md-2 mb-0">Year</label>
                    <div class="col-md-4 pl-md-0">
                        {{ quota.Year }}
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label class="col-md-2 mb-0">Total number of pass/e-tickets</label>
                    <div class="col-md-1 pl-md-0">
                        <input type="number" class="form-control" v-model="quota.TotalPass" max="9999" min="1" step="1"
                            :required="quota.Year == currentYear" />
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label class="col-md-2 mb-0">Number of pass/e-tickets allowed per booking</label>
                    <div class="col-md-1 pl-md-0">
                        <input type="number" class="form-control" v-model="quota.PassAllowedPerBooking" max="9999"
                            min="1" step="1" :required="quota.Year == currentYear" />
                    </div>
                </div>
            </template>

            <div class="form-group row align-items-center">
                <div class="col-md-3">
                    <button type="button" class="btn btn-secondary"
                        @click="$router.push({ name: 'manageCorporatePass' })">
                        <i class="fa fa-reply mr-2"></i>Back
                    </button>
                </div>
                <div class="col-md-3 text-right">
                    <button type="submit" class="btn btn-primary">
                        <i :class="$route.params.id ? 'fa fa-save' : 'fa fa-plus'"></i>
                        {{ $route.params.id ? "Save" : "Add" }}
                    </button>
                </div>
            </div>
        </form>
        <!-- /Form -->
    </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";

export default {
    data() {
        return {
            companies: [],
            company: config.DEFAULT_COMPANY,
            type: config.CORPORATE_PASS_TYPE_PHYSICAL_CARD,
            code: "",
            name: "",
            quotas: null,
            totalPass: "",
            passAllowedPerBooking: "",
            collectionDay: "",
            returnDay: "",
            returnDayAfterPH: "",
            status: "Active"
        }
    },

    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
        currentYear() {
            return new Date().getFullYear();
        },
        corporatePassType() {
            let type = {
                physicalCard: config.CORPORATE_PASS_TYPE_PHYSICAL_CARD,
                eTicket: config.CORPORATE_PASS_TYPE_ETICKET
            }
            return type;
        }
    },

    methods: {
        getCompanies() {
            let param = {
                Token: this.token,
            };
            this.$store.state.isLoading = true;
            API.getCompanies(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.companies = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getCorporatePassDetail() {
            let param = {
                Token: this.token,
                Id: this.$route.params.id
            };
            this.$store.state.isLoading = true;
            API.getCorporatePassDetail(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        let data = response.data.record;
                        if (!data) this.$router.replace({ name: "manageCorporatePass" });
                        this.company = data.Company;
                        this.type = data.Type;
                        this.code = data.Code;
                        this.name = data.Name;
                        this.totalPass = data.TotalPass;
                        this.passAllowedPerBooking = data.PassAllowedPerBooking;
                        this.collectionDay = data.CollectionDay;
                        this.returnDay = data.ReturnDay;
                        this.returnDayAfterPH = data.ReturnDayAfterPH;
                        this.status = data.Status;
                        this.quotas = data.Quotas;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        save() {
            //validation
            if (this.type == config.CORPORATE_PASS_TYPE_PHYSICAL_CARD) {
                if (parseInt(this.passAllowedPerBooking) > parseInt(this.totalPass)) {
                    alert("Number of pass allowed per booking cannot exceed Total number of pass.");
                    return;
                }
            }
            else if (this.type == config.CORPORATE_PASS_TYPE_ETICKET) {
                let message = "";
                let isValid = true
                for (let quota of this.quotas) {
                    if (parseInt(quota.PassAllowedPerBooking) > parseInt(quota.TotalPass)) {
                        message += `[${quota.Year}]: Number of e-ticket allowed per booking cannot exceed Total number of e-tickets.\n`;
                        isValid = false;
                    }
                }
                if (!isValid) { alert(message); return; }
            }

            let param = {
                Token: this.token,
                Id: this.$route.params.id,
                Company: this.company,
                Type: this.type,
                Code: this.code,
                Name: this.name,
                TotalPass: this.totalPass,
                PassAllowedPerBooking: this.passAllowedPerBooking,
                CollectionDay: this.collectionDay,
                ReturnDay: this.returnDay,
                ReturnDayAfterPH: this.returnDayAfterPH,
                Status: this.status,
                Quotas: this.quotas
            };
            let confirmationText = "Are you sure you want to " + (this.$route.params.id ? "save" : "add") + " the corporate pass?";
            this.$swal({
                title: "Are you sure?",
                text: confirmationText,
                icon: "info",
                buttons: true,
                dangerMode: false,
            }).then((willSave) => {
                if (willSave) {
                    this.$store.state.isLoading = true;
                    API.saveCorporatePass(param)
                        .then((response) => {
                            this.$store.state.isLoading = false;
                            this.$swal(response.data.message, {
                                icon: response.data.success ? "success" : "error",
                            });
                            if (response.data.success) {
                                this.$router.replace({ name: "manageCorporatePass" });
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                            this.$store.state.isLoading = false;
                            this.$swal(error.response.data.Message, { icon: "error" });
                        });
                }
            });
        }
    },

    created() {
        if (this.role != "admin") {
            this.$router.replace({ name: "home" });
        }
        if (this.$route.params.id) { //edit mode
            this.getCorporatePassDetail();
        } else { //add mode
            this.getCompanies();
            this.quotas = [{ Year: this.currentYear, TotalPass: "", PassAllowedPerBooking: "" }, { Year: this.currentYear + 1, TotalPass: "", PassAllowedPerBooking: "" }];
        }
    }
}
</script>

<style scoped>
.fit-content {
    max-width: fit-content;
}
</style>


// WEBPACK FOOTER //
// src/components/Corppass/ManageCorporatePassDetail.vue